// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__u7EqB","container":"styles_container__ucell"};